import { btnType } from '../../atoms/button';

export const iconBtnStyle = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  HIGH_CONTRAST: 'HIGH_CONTRAST',
  MEDIUM_CONTRAST: 'MEDIUM_CONTRAST',
  LOW_CONTRAST: 'LOW_CONTRAST',
  DARK: 'DARK',
};

export const iconBtnPosition = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const iconBtnType = btnType;
